import differenceInMonths from "date-fns/differenceInMonths";
import LocaleContext from "components/i18n/LocaleContext";
import { useContext } from "react";

interface ITotalRatingsLineProps {
  totalRatings: number;
  periodStart: Date;
  periodEnd: Date;
}

function TotalRatingsLine({ totalRatings, periodEnd, periodStart }: ITotalRatingsLineProps) {
  const diffInMonths = differenceInMonths(periodEnd, periodStart);
  const locale = useContext(LocaleContext);

  if (locale === "BRA") {
    return (
      <p className="whitespace-nowrap font-aeonik text-sm font-medium tracking-wide text-slate-500">
        <strong>{totalRatings}</strong> {totalRatings === 1 ? "voto" : "votos"} nos últimos{" "}
        <strong>{diffInMonths}</strong> meses
      </p>
    );
  }

  return (
    <p className="font-aeonik text-sm font-medium tracking-wide text-slate-500">
      <strong>{totalRatings}</strong> {totalRatings === 1 ? "rating" : "ratings"} in the last{" "}
      <strong>{diffInMonths}</strong> months
    </p>
  );
}

export default TotalRatingsLine;
